interface generateConfigProps {
  preferredCardSize: number;
  variant: 'fixed' | 'fluid' | 'single';
  gap: number;
}

const DEFAULT_CONTAINER_PADDING = 40;
const MOBILE_CARD_SIZE = 2;
const TABLET_CARD_SIZE = 3;
const DESKTOP_CARD_SIZE = 4;

export const generateConfig = ({
  variant,
  gap,
  preferredCardSize,
}: generateConfigProps): {
  breakpoints?: {
    [x: number]: {
      slidesPerView: number;
      spaceBetween: number;
      slidesPerGroup: number;
    };
  };
  slidesPerGroupAuto?: boolean;
  slidesPerView?: 'auto';
} => {
  if (variant === 'fixed') {
    return {
      slidesPerView: 'auto',
      slidesPerGroupAuto: true,
    };
  }

  if (variant === 'single') {
    return {
      breakpoints: {
        360: {
          slidesPerView: 1,
          spaceBetween: gap,
          slidesPerGroup: 1,
        },
      },
    };
  }

  const breakpoints = {
    320: {
      slidesPerView: 1.2,
      spaceBetween: gap,
      slidesPerGroup: 1,
    },
    [preferredCardSize * MOBILE_CARD_SIZE +
    gap * MOBILE_CARD_SIZE +
    DEFAULT_CONTAINER_PADDING]: {
      slidesPerView: MOBILE_CARD_SIZE,
      spaceBetween: gap,
      slidesPerGroup: MOBILE_CARD_SIZE,
    },
    [preferredCardSize * TABLET_CARD_SIZE +
    gap * TABLET_CARD_SIZE +
    DEFAULT_CONTAINER_PADDING]: {
      slidesPerView: TABLET_CARD_SIZE,
      spaceBetween: gap,
      slidesPerGroup: TABLET_CARD_SIZE,
    },
    [preferredCardSize * DESKTOP_CARD_SIZE +
    gap * DESKTOP_CARD_SIZE +
    DEFAULT_CONTAINER_PADDING]: {
      slidesPerView: DESKTOP_CARD_SIZE,
      spaceBetween: gap,
      slidesPerGroup: DESKTOP_CARD_SIZE,
    },
  };

  return {
    breakpoints,
  };
};
